import { HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { exhaustMap, take } from 'rxjs';
import { Injectable, Injector, inject } from '@angular/core';

@Injectable()
export class loggerInterceptor implements HttpInterceptor{

  constructor(private __injector:Injector){}

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
      
      let authService = this.__injector.get(AuthService);
      return authService.user.pipe(
          take(1),
          exhaustMap((user:any)=>{
              
              if (!user) {
                  return next.handle(req);
              }
              const modifiedReq = req.clone({
                  setHeaders : {
                      Authorization : 'Bearer '+ user.access_token
                  }
              });
              return next.handle(modifiedReq);
          })
      );
  }






  
}
